// removed by extract-text-webpack-plugin
module.exports = {"container":"_3wAGW"};


//////////////////
// WEBPACK FOOTER
// ./app/components/text-editor/text-editor-entity-link.scss
// module id = 798
// module chunks = 3 4 5 6 7